import { render, staticRenderFns } from "./CommonAlert.vue?vue&type=template&id=2a134ef0&"
import script from "./CommonAlert.vue?vue&type=script&lang=js&"
export * from "./CommonAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports